import axios from 'axios';

import { getGuestAccessRefreshToken } from '../utils';

const guestAccessServiceURL = process.env.VUE_APP_GUEST_ACCESS_URL;

export let promise = undefined;

export const refreshGuestAccessToken = () => {
    if (promise) return promise;

    const refreshToken = getGuestAccessRefreshToken();

    promise = axios
        .post(
            `${guestAccessServiceURL}/api/v1/guests/refresh/`,
            {},
            {
                headers: {
                    Authorization: 'Guest ' + refreshToken,
                },
            }
        )
        .then((response) => {
            promise = undefined;

            return response;
        })
        .catch((error) => {
            promise = undefined;

            throw error;
        });

    return promise;
};
